import { privateAxios } from "../../../config/apiConfig";
import {
  CREATE_BANNER_FAILURE,
  CREATE_BANNER_REQUEST,
  GET_ALL_BANNER_SUCCESS,
  GET_ALL_BANNER_REQUEST,
  GET_ALL_BANNER_FAILURE,
  DELETE_BANNER_REQUEST,
  DELETE_BANNER_FAILURE,
  UPDATE_BANNER_REQUEST,
  UPDATE_BANNER_FAILURE,
  GET_ALL_SPECIAL_OFFER_BANNER_FAILURE,
  GET_ALL_SPECIAL_OFFER_BANNER_REQUEST,
  GET_ALL_SPECIAL_OFFER_BANNER_SUCCESS,
  DELETE_BANNER_SUCCESS,
  CREATE_BANNER_SUCCESS,
  UPDATE_BANNER_SUCCESS
} from "./ActionType";
import { toast } from "react-toastify";

export const getAllBanner = () => async (dispatch) => {
  dispatch({ type: GET_ALL_BANNER_REQUEST });
  try {
    const { data } = await privateAxios.get(`admin/banners`);
    dispatch({ type: GET_ALL_BANNER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_BANNER_FAILURE, payload: error.message });
  }
};

export const getAllSpecialOfferBanner = () => async (dispatch) => {
  dispatch({ type: GET_ALL_SPECIAL_OFFER_BANNER_REQUEST });
  try {
    const { data } = await privateAxios.get(`admin/banners/special`);
    dispatch({ type: GET_ALL_SPECIAL_OFFER_BANNER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_ALL_SPECIAL_OFFER_BANNER_FAILURE,
      payload: error.message
    });
  }
};

export const createBanner = (bannerData, formData) => async (dispatch) => {
  dispatch({ type: CREATE_BANNER_REQUEST });
  try {
    const { data } = await privateAxios.post(`admin/banner`, bannerData);

    if (data && data.id) {
      const uploadResponse = await privateAxios.put(
        `admin/banner/${data.id}/upload`,
        formData // image data
        // 👇 Don’t manually set content-type, browser/axios sets it correctly with boundary
      );
      dispatch(getAllBanner());
      dispatch(getAllSpecialOfferBanner());
      toast.success("Banner Uploaded Successfully !!");
      dispatch({ type: CREATE_BANNER_SUCCESS, payload: data });
    }
  } catch (error) {
    console.error("Error creating/uploading banner:", error);

    const errorMsg =
      error?.response?.data?.status === "FAIL"
        ? error.response.data.response
        : "Failed Banner Creations !!";

    toast.error(errorMsg);
    dispatch({ type: CREATE_BANNER_FAILURE, payload: errorMsg });
  }
};


export const updateBanner = (bannerId, bannerData, formData) => async (dispatch) => {
  dispatch({ type: UPDATE_BANNER_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `admin/banner/${bannerId}`,
      bannerData
    );
    if (data.status === "SUCCESS") {
      if (formData && formData.get("imageFile") && formData.get("imageFile").name) {
        const uploadResponse = await privateAxios.put(
          `admin/banner/${data.response.id}/upload`,
          formData // image data
          // 👇 Don’t manually set content-type, browser/axios sets it correctly with boundary
        );
      }
      dispatch(getAllBanner());
      dispatch(getAllSpecialOfferBanner());
      toast.success("Banner Updated Successfully");
      dispatch({ type: UPDATE_BANNER_SUCCESS, payload: data });
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_BANNER_FAILURE, payload: error.message });
  }
};

export const deleteBanner = (bannerId) => async (dispatch) => {
  dispatch({ type: DELETE_BANNER_REQUEST });
  try {
    const { data } = await privateAxios.delete(`admin/banner/${bannerId}`);
    if (data.status === "SUCCESS") {
      dispatch({ type: DELETE_BANNER_SUCCESS, payload: bannerId })
      dispatch(getAllBanner());
      dispatch(getAllSpecialOfferBanner());
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: DELETE_BANNER_FAILURE, payload: error.message });
  }
};
